/* DENSA — VİDEO KURTARMA v2.1 (21 Ağu 2026)
   v2.1 (kurucu: 'ürün sayfasındaki formül kartı videoları otomatik oynamıyor'): KÖK — PDP'de videoyu BAŞLATAN
   mekanizma yoktu; ana sayfada karusel (densa-fa-karusel) aktif kartı başlatıyor, PDP'de karusel yok.
   Çözüm: GÖRÜŞ ALANI GÖZLEMCİSİ — karusel yönetiminde OLMAYAN (.fa-rail dışı) kapsam videoları,
   %40 görünür olunca kaynağı bağlanıp (data-mp4 / data-hls, HLS yalnız native destekte) sessiz başlatılır;
   görüş alanından çıkınca durdurulur (tasarruf). Karusel videolarına DOKUNULMAZ (çift yönetici olmaz).
   v2.0: ① kapsam data-hls/data-mp4 + autoplay+muted ② CANPLAY YENİDEN DENEME (play isteği işaretlenir,
   oynatılabilir olunca tekrar denenir). v1.0: düşük güç modu reddi → poster + dokununca oynat + zarif işaret.
   Yükleme noktası: snippets/densa-istek.liquid (site geneli). */
(function () {
  function kaynakBagla(v) {
    if (v.dataset.kaynakBagli || v.getAttribute('src') || v.querySelector('source')) return;
    var mp4 = v.dataset.mp4, hls = v.dataset.hls;
    var hlsOlur = hls && v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl');
    var sec = hlsOlur ? hls : (mp4 || hls);
    if (!sec) return;
    v.dataset.kaynakBagli = '1';
    v.preload = 'auto';
    v.src = sec;
    try { if (v.readyState === 0) v.load(); } catch (e) {}
  }

  function kur(v) {
    if (v.dataset.gucKuruldu) return;
    v.dataset.gucKuruldu = '1';
    var kart = v.closest('.fa-kart') || v.parentElement;

    function isaretGoster(goster) {
      if (!kart) return;
      kart.classList.toggle('fa-video-elle', !!goster);
    }

    var eskiPlay = v.play.bind(v);
    v.play = function () {
      v.dataset.oynatIstendi = '1';
      var p = eskiPlay();
      if (p && p.then) {
        p.then(function () { isaretGoster(false); })
         .catch(function () { isaretGoster(true); });
      }
      return p;
    };
    v.addEventListener('pause', function () {
      /* elle/mantıkla durduruldu ise istek bayrağı kalksın ki canplay yeniden başlatmasın */
      if (v.readyState >= 2) v.dataset.oynatIstendi = '0';
    });
    function yenidenDene() {
      if (v.dataset.oynatIstendi === '1' && v.paused) {
        var p = eskiPlay();
        if (p && p.catch) p.catch(function () {});
      }
    }
    v.addEventListener('canplay', yenidenDene);
    v.addEventListener('loadeddata', yenidenDene);

    function elleOynat() {
      if (v.paused) {
        kaynakBagla(v);
        v.dataset.oynatIstendi = '1';
        var p = eskiPlay();
        if (p && p.catch) p.catch(function () {});
        isaretGoster(false);
      }
    }
    if (kart) {
      kart.addEventListener('click', elleOynat);
      kart.addEventListener('touchend', elleOynat, { passive: true });
    }

    v.addEventListener('playing', function () { isaretGoster(false); });
    v.addEventListener('pause', function () {
      if (!kart) return;
      if (kart.classList.contains('aktif')) isaretGoster(true);
    });

    /* v2.1 — karusel yönetiminde olmayan videolar görüş alanıyla yaşar */
    if (!v.closest('.fa-rail') && 'IntersectionObserver' in window) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      var io = new IntersectionObserver(function (girisler) {
        girisler.forEach(function (g) {
          if (g.isIntersecting) {
            kaynakBagla(v);
            v.dataset.oynatIstendi = '1';
            var p = eskiPlay();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.4 });
      io.observe(v);
    }
  }

  function tara() {
    var vs = document.querySelectorAll('.fa-medya video, video[data-hls], video[data-mp4], video[autoplay][muted]');
    for (var i = 0; i < vs.length; i++) kur(vs[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tara);
  else tara();
  window.addEventListener('load', function () { setTimeout(tara, 400); });
  try { new MutationObserver(function(){ tara(); }).observe(document.documentElement, { childList:true, subtree:true }); } catch (e) {}
})();
